/**
 * Determine if an item is an object.
 */
export function isObject(item: any): boolean {
  return Object.prototype.toString.call(item) === '[object Object]';
}
